import React from 'react';
import SessionRow from './SessionRow';

const TrainingSessionsTable = ({
  sessions,
  expandedSessions,
  onToggleExpand,
  onSchedule,
  onEdit,
  onDelete,
  onViewDetails,
  onReschedule,
  onQuickSchedule,
  getSessionStatus,
  formatSessionTiming,
  formatCrewNames,
  canModify,
}) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Session
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Date & Duration
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Status
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Location
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Assigned Crews
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {sessions.map((session) => (
            <React.Fragment key={session.id}>
              <SessionRow
                session={session}
                isChild={false}
                parentSessionPresent={session.parent_session_present}
                onToggleExpand={onToggleExpand}
                isExpanded={expandedSessions.has(session.id)}
                handleViewDetails={onViewDetails}
                handleEdit={onEdit}
                handleSchedule={onSchedule}
                handleDelete={onDelete}
                handleReschedule={onReschedule}
                handleQuickSchedule={onQuickSchedule}
                formatCrewNames={formatCrewNames}
                formatSessionTiming={formatSessionTiming}
                getSessionStatus={getSessionStatus}
                canModify={canModify}
              />
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TrainingSessionsTable;
